// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","5547":"ff22a32d","9397":"c815f8a6"}[chunkId] + ".css";
};